export default "__VITE_ASSET__74a207db__"